import { useState } from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { PencilFill } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

function GameLabelRenamer(props) {
    const { t } = useTranslation('messages');
    const [newLabel, setNewLabel] = useState(props.gameLabel.name);
    const [show, setShow] = useState(false);

    return (
        <>
            <Button size="sm" variant="outline-primary" onClick={() => setShow(true)}>
                <PencilFill size={14} />
            </Button>
            <Offcanvas show={show} onHide={() => setShow(false)} placement="bottom">
                <Offcanvas.Header closeButton data-bs-theme="dark"
                    style={{ backgroundColor: '#2d1b4e', color: '#fff' }}>
                    <Offcanvas.Title style={{ color: '#fff' }}>{props.gameLabel.name}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body style={{ backgroundColor: '#fdf4ff' }}>
                    <Form onSubmit={(e) => renameLabel(e, props.renameLabel, props.gameLabel.gameLabelId, newLabel, () => setShow(false))}>
                        <Form.Group className="mb-3" controlId={"RenameGameLabelFormGroup_" + props.gameLabel.gameLabelId}>
                            <Form.Control
                                type="text"
                                value={newLabel}
                                placeholder={t('private_area.games_tab.labels_rename_form_placeholder')}
                                onChange={e => setNewLabel(e.target.value)}
                            />
                        </Form.Group>
                        <Button type="submit"
                            style={{ backgroundColor: '#6d28d9', borderColor: '#6d28d9', color: '#fff' }}>
                            {t('private_area.games_tab.labels_rename_form_button_text')}
                        </Button>
                    </Form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}

function renameLabel(e, renameFn, gameLabelId, newLabel, handleClose) {
    e.preventDefault();
    if (!newLabel) return;
    renameFn(gameLabelId, newLabel);
    handleClose();
}

export default GameLabelRenamer;
